import { serviceData } from '@/l-data/services';
import Translatable from '../translatable_text/Translatable';

function Services() {
  return (
    <section className="services-boxs section-padding">
      <div className="w-full max-w-7xl mx-auto px-4">
        <div className="sec-head mb-80">
          <h2 className="sub-title main-color mb-25">
            <Translatable>
              Explore Our Services
            </Translatable>
          </h2>
          <div className="bord pt-25 bord-thin-top flex items-center">
            <h2 className="fw-600 text-u ls1 text-4xl">
              <Translatable>What We</Translatable>  <span className="fw-200"><Translatable>Offer</Translatable></span>
            </h2>
          </div>
        </div>
        <div className="grid grid-cols-12 gap-6 pt-30 d-rotate wow">
          {serviceData.map((item: any, i: number) => (
            <div key={i} className="col-span-12 md:col-span-6 lg:col-span-3 items rotate-text">
              <div className="item-box flex flex-col items-center lg:items-start bg md-mb50">
                <div className=" icon mb-30 opacity-70">
                  <img src={item.img} alt="img" />
                </div>
                <h5 className="mb-15 text-u">
                  <Translatable>{item.title}</Translatable>
                </h5>
                <span className='item-box-desc'>
                  <Translatable>
                    {item.desc}
                  </Translatable>
                </span>
                <a href={`${item.link}/${item.id}`} className="flex rmore mt-30 gap-2 underline link-hover-effect centered-element-resp">
                  <span className="sub-title ">
                    <Translatable>Explore the app</Translatable>
                  </span>
                  <img 
                    src="/light/assets/imgs/arrow-right.webp"
                    alt="icon"
                    className="icon-img-20 ml-5 mr-5"
                    width="40px"
                    height="40px"
                  />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
